import React from 'react'
import HomepageCarousel from './components/carousel/homepageCarousel'
import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import './index.css'
import Methodology from './components/sections/transformationsPreview'
import ReviewCarousel from './components/carousel/reviewCarousel'
import ContactForm from './contact/contactForm'
import HomepageGallery from './components/sections/transformationsPreview'
import { useNavigate } from 'react-router-dom'
import WhyChooseUs from './components/sections/whyChooseUs'
import OneLineStrip from './components/sections/oneLineStrip'
import Services from './components/sections/services'

const Homepage = () => {
  const navigate = useNavigate()

  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
      <Box width={1} sx={{ mx: 'auto' }}>
        <HomepageCarousel navigateLink={() => navigateLink('/contact')}/>
        <OneLineStrip />
        <WhyChooseUs />
        <Services />

        <Box>
          <HomepageGallery navigateLink={navigateLink} />
        </Box>

        <ReviewCarousel />

        <Box>
          <ContactForm />
        </Box>
      </Box>
  )
}

export default Homepage
